"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _ReceiptAcknowledgementEntityDto = _interopRequireDefault(require("../model/ReceiptAcknowledgementEntityDto"));

var _StatusMessageDTO = _interopRequireDefault(require("../model/StatusMessageDTO"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* TreatmentPlanRequestsReceiptAcknowledgement service.
* @module 2/TreatmentPlanRequestsReceiptAcknowledgementApi
* @version 1.1.1
*/
var TreatmentPlanRequestsReceiptAcknowledgementApi = /*#__PURE__*/function () {
  /**
  * Constructs a new TreatmentPlanRequestsReceiptAcknowledgementApi. 
  * @alias module:2/TreatmentPlanRequestsReceiptAcknowledgementApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TreatmentPlanRequestsReceiptAcknowledgementApi(apiClient) {
    _classCallCheck(this, TreatmentPlanRequestsReceiptAcknowledgementApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Gets the list of receipt acknowledgment for the specified treatment plan request.
   * @param {String} id The request identifier.
   * @param {Object} opts Optional parameters
   * @param {String} opts.dateTimeFrom The start date for retrieving receipt acknowledgment.
   * @param {String} opts.dateTimeTo The end date for retrieving receipt acknowledgment.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/ReceiptAcknowledgementEntityDto>} and HTTP response
   */


  _createClass(TreatmentPlanRequestsReceiptAcknowledgementApi, [{
    key: "treatmentplanrequestsIdAcknowledgementsGetWithHttpInfo",
    value: function treatmentplanrequestsIdAcknowledgementsGetWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling treatmentplanrequestsIdAcknowledgementsGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {
        'dateTimeFrom': opts['dateTimeFrom'],
        'dateTimeTo': opts['dateTimeTo']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = [_ReceiptAcknowledgementEntityDto["default"]];
      return this.apiClient.callApi('/treatmentplanrequests/{id}/acknowledgements', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the list of receipt acknowledgment for the specified treatment plan request.
     * @param {String} id The request identifier.
     * @param {Object} opts Optional parameters
     * @param {String} opts.dateTimeFrom The start date for retrieving receipt acknowledgment.
     * @param {String} opts.dateTimeTo The end date for retrieving receipt acknowledgment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/ReceiptAcknowledgementEntityDto>}
     */

  }, {
    key: "treatmentplanrequestsIdAcknowledgementsGet",
    value: function treatmentplanrequestsIdAcknowledgementsGet(id, opts) {
      return this.treatmentplanrequestsIdAcknowledgementsGetWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Stores a technical acknowledgement indicating the successful reception  of the specified treatment plan request.
     * Once an acknowledgement has been received for a treatment plan request,  the corresponding request will no longer be included as part of  the response when retrieving the list of available requests  (client identification is derived from the access token).
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "treatmentplanrequestsIdAcknowledgementsPostWithHttpInfo",
    value: function treatmentplanrequestsIdAcknowledgementsPostWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling treatmentplanrequestsIdAcknowledgementsPost");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = null;
      return this.apiClient.callApi('/treatmentplanrequests/{id}/acknowledgements', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Stores a technical acknowledgement indicating the successful reception  of the specified treatment plan request.
     * Once an acknowledgement has been received for a treatment plan request,  the corresponding request will no longer be included as part of  the response when retrieving the list of available requests  (client identification is derived from the access token).
     * @param {String} id The request identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "treatmentplanrequestsIdAcknowledgementsPost",
    value: function treatmentplanrequestsIdAcknowledgementsPost(id) {
      return this.treatmentplanrequestsIdAcknowledgementsPostWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return TreatmentPlanRequestsReceiptAcknowledgementApi;
}();

exports["default"] = TreatmentPlanRequestsReceiptAcknowledgementApi;